import React from 'react';
import { useTranslation } from 'react-i18next';
import { Mail, Phone, MapPin } from 'lucide-react';

const Contact = () => {
  const { t } = useTranslation();

  const contactDetails = [
    {
      icon: Mail,
      label: t('contact.email'),
      value: 'info@edgegemi.com',
      href: 'mailto:info@edgegemi.com'
    },
    {
      icon: Phone,
      label: t('contact.phone'),
      value: '+90 532 136 82 03',
      href: 'tel:+905321368203'
    },
    {
      icon: MapPin,
      label: t('contact.location'),
      value: t('contact.locationValue'),
      href: null
    }
  ];

  return (
    <div className="page-contact">
      <section className="page-hero">
        <div className="container">
          <h1 className="page-title">{t('contact.title')}</h1>
          <p className="page-subtitle">{t('contact.subtitle')}</p>
        </div>
      </section>

      <section className="contact-content">
        <div className="container">
          <div className="contact-grid">
            <div className="contact-info">
              <h2 className="contact-section-title">{t('contact.sectionTitle')}</h2>
              <p className="contact-intro">
                {t('contact.intro')}
              </p>

              <div className="contact-details">
                {contactDetails.map((detail, index) => {
                  const IconComponent = detail.icon;
                  return (
                    <div key={index} className="contact-detail-card">
                      <div className="contact-detail-icon">
                        <IconComponent size={24} />
                      </div>
                      <div className="contact-detail-content">
                        <h4>{detail.label}</h4>
                        {detail.href ? (
                          <a href={detail.href} className="contact-detail-link">
                            {detail.value}
                          </a>
                        ) : (
                          <p>{detail.value}</p>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            <div className="contact-image">
              <img 
                src="https://customer-assets.emergentagent.com/job_edge-marine-corp/artifacts/fxe5bwbz_WhatsApp%20Image%202026-02-05%20at%2019.24.02%20%283%29.jpeg" 
                alt="ESVAGT Offshore Vessels - EDGE MARINE Projects"
                className="rounded-image"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
